import type { PermissionRole } from "@remi/types/permissions";

export const REMI_ORG_RESTRICTED_ROLES = [
  "REMI_OPS",
  "REMI_USER",
  "REMI_SALES",
  "REMI_SALES_ADMIN",
  "REMI_ADMIN",
  "REMI_AI_OPERATIONS",
  "REMI_COMPLIANCE",
  "REMI_COMPLIANCE_ADMIN",
  "REMI_ENGINEER",
  "REMI_AUTOMATIONS",
  "REMI_DESIGNER",
  "REMI_FINANCIAL",
  "REMI_FINANCIAL_ADMIN",
  "REMI_QUOTE_ADMIN",
  "REMI_REGIONAL_MANAGER",
  "REMI_DEADLINE_MANAGER",
  "REMI_CHANGE_ORDER_MANAGER",
  "REMI_WORK_ORDER_MANAGER",
  "REMI_DISPATCH",
  "REMI_CHANGE_ORDER_SPECIALIST",
  "REMI_ACCOUNT_MANAGEMENT_LEAD",
  "REMI_ACCOUNT_MANAGER",
  "REMI_QUOTING",
  "REMI_CLAIM_CAPTURE_TEAM",
  "REMI_PERMISSIONS_MANAGER",
  "REMI_MCP_USER",
  "REMI_MARKETING_WEBSITE",
  "AUTONOMOUS_AGENT",
  "ESTIMATE_ADMIN",
  "IMPERSONATOR",
  "REMI_IMPERSONATION_AUDITOR",
  "INVALID",
] as const satisfies PermissionRole[];
